import styled from 'styled-components';
import { motion } from 'framer-motion';

const Background = styled(motion.div)`
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 100;
`;

const ModalContainer = styled(motion.div)`
  z-index: 110;
  cursor: default;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);

  padding: 40px 32px 24px 32px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: ${({ theme }) => theme.colors.backgroundColorWhite};
  ${({ theme }) => theme.shadows.cardShadow};

  border-radius: 8px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;

  & button:first-of-type {
    margin-right: 16px;
  }
`;

export {
  Background,
  ModalContainer,
  ButtonsContainer,
};
